module.exports = __webpack_public_path__ + "img/my.3feb4794.svg";